import { Box, Button, Container, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { PartnerService } from "../services/PartnerService";
import { CurrentUser } from "../models/CurrentUser";
import { Partner } from "../models/Partner";
import { WebStorageService } from "../services/WebStorageService";
import { CURRENT_USER } from "../contants/constants";
import { Utils } from "../helpers/utils";
import { Phone, Sms } from "@mui/icons-material";
import { Link } from "react-router-dom";

export default function MyContactUs() {
    const webStorageService = new WebStorageService();
    const partnerService: PartnerService = new PartnerService();
    const [user, setUser] = useState<CurrentUser>(webStorageService.getJson(CURRENT_USER));
    const [partner, setPartner] = useState<Partner>(new Partner());

    useEffect(() => {
        partnerService.Get(Number(user.ID)).then(response => {
            if(response.Data != undefined)
                setPartner(response.Data);
        }).catch(error => {
            console.error(error);
        })
    }, []);


    return (
        <Container sx={{ alignItems: "baseline", flexDirection: "column", paddingTop: 15 }}>
            <Typography variant="h5" sx={{ marginBottom: 2 }}>Has concern or suggestions? we would be happy to attend to it.</Typography>
            <Paper sx={{ padding: 2, marginBottom: 2, backgroundColor: "#f5e7e7" }}>
                <Box sx={{display:'flex', flexDirection:"column", justifyContent:"space-between"}}>
                    <Typography variant="subtitle1" color="#999999" sx={{ marginBottom: 1 }}>Company contact details</Typography>
                    
                    <br></br>
                    <Typography variant="subtitle2" color="primary">Business Name</Typography>
                    <Typography variant="subtitle1">Pipoy General Merchandise OPC</Typography>
                    
                    <br></br>
                    <Typography variant="subtitle2" color="primary">Primary Mobile Number</Typography>
                    <Typography variant="subtitle1">0997 9504 208</Typography>

                    <br></br>
                    <Typography variant="subtitle2" color="primary">Our Email</Typography>
                    <Typography variant="subtitle1">pipoygenmerch@gmail.com </Typography>

                    <br></br>
                    <Typography variant="subtitle2" color="primary">Address</Typography>
                    <Typography variant="subtitle1">San Gabriel St. corner Batasan-San Mateo Road, Batasan Hills, Q.C.</Typography>

                    <br></br>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button href="sms://09979504208" variant="contained" size="large" color="error">Send us a message</Button>
                </Box>
            </Paper>
        </Container>
    );
}